import { render } from "./DownloadApkModal.vue?vue&type=template&id=2c278046"
import script from "./DownloadApkModal.vue?vue&type=script&lang=js"
export * from "./DownloadApkModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__